import { LogLevel, LogType } from "../contracts/LogServiceOptions";
export const logServiceDefaultOptions = Object.freeze({
    debug: false,
    level: LogLevel.Low,
    type: LogType.Log
});
